"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Crown, Shield, Swords } from "lucide-react";
const topPlayers = [{
  rank: 1,
  name: "HMS 1/2 (80/20)",
  level: "52,400",
  playerClass: "Bulk Steel",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1639953/img/avatar_warrior.png"
}, {
  rank: 2,
  name: "Shredded Scrap",
  level: "38,150",
  playerClass: "High Purity",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1639953/img/avatar_bow.png"
}, {
  rank: 3,
  name: "P&S Scrap",
  level: "24,900",
  playerClass: "Plate & Structural",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1639953/img/avatar_mage.png"
}, {
  rank: 4,
  name: "No. 1 HMS",
  level: "18,200",
  playerClass: "Premium Grade",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1639953/img/avatar_blader.png"
}, {
  rank: 5,
  name: "Cast Iron",
  level: "12,450",
  playerClass: "Machinery",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1639953/img/avatar_rogue.png"
}];
const topGuilds = [{
  rank: 1,
  name: "İskenderun, TR",
  master: "Global Hub",
  points: "142 Vessels",
  emblem: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1639953/img/guild_immortals.png"
}, {
  rank: 2,
  name: "New York, USA",
  master: "Export Hub",
  points: "98 Vessels",
  emblem: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1639953/img/guild_vanguard.png"
}, {
  rank: 3,
  name: "Kelowna, BC",
  master: "Sourcing Hub",
  points: "64 Vessels",
  emblem: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1639953/img/guild_eclipse.png"
}, {
  rank: 4,
  name: "Asian Ports",
  master: "Global Trade",
  points: "42 Vessels",
  emblem: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1639953/img/guild_blood.png"
}, {
  rank: 5,
  name: "European Hubs",
  master: "Regional Trade",
  points: "28 Vessels",
  emblem: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1639953/img/guild_dragon.png"
}];
const RankBadge = ({
  rank
}: {
  rank: number;
}) => {
  if (rank === 1) {
    return <Badge variant="outline" className="border-primary bg-primary/10 text-primary font-default">
        <Crown className="mr-1 size-3" /> 1st
      </Badge>;
  }
  if (rank === 2) {
    return <Badge variant="outline" className="border-secondary bg-secondary/10 text-secondary font-default">
        <Crown className="mr-1 size-3" /> 2nd
      </Badge>;
  }
  if (rank === 3) {
    return <Badge variant="outline" className="border-muted-foreground bg-muted-foreground/10 text-muted-foreground font-default">
        <Crown className="mr-1 size-3" /> 3rd
      </Badge>;
  }
  return <span className="px-2 font-mono text-sm font-medium text-muted-foreground">
      {rank}th
    </span>;
};
export default function ImperialHallOfFame() {
  return;
}